import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";

export const GlobalFileCategoryService = {
    List(callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.GLOBAL_FILE_CATEGORY, null, wait).then((data) => {
            callback(data);
        });
    },
}; 